/**
 * @file 展示一些风险提示的tip
 */
import { useRef } from 'react';
import { Modal, Button } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import clsx from 'clsx';
import styles from './index.module.scss';
import { PoolInfo } from '@/types/pool';
import { isLBTCvPool, isLombardPool } from '@/utils/common';
import { debounce } from 'lodash-es';

interface Props {
  show: boolean;
  onConfirm: (v: boolean) => void;
  onClose: () => void;
  content: string | React.ReactNode;
  buttonText: string;
  title?: string;
  currentBtnProps?: string;
  poolInfo?: PoolInfo;
  loading?: boolean;
}

export const TipModal = (props: Props) => {
  const {
    title,
    show,
    buttonText,
    content,
    onConfirm,
    onClose,
    currentBtnProps,
    poolInfo,
    loading,
  } = props;
  const checkedRef = useRef(false);
  const fm = useFm();

  return (
    <Modal
      open={show}
      onClose={onClose}
      title={title ?? fm('stakingNotice')}
      width={480}
      footer={null}
      modal={false}
      overlayClassName={styles.overlay}
    >
      <div className={styles.content}>{content}</div>
      {isLBTCvPool(poolInfo?.id) ? (
        <div className={styles.buttonContainer}>
          <Button
            loading={loading}
            variant="primary"
            className={clsx(styles.button, currentBtnProps)}
            onClick={() => {
              onConfirm(checkedRef.current);
            }}
          >
            {buttonText}
          </Button>
          <Button
            variant="default"
            className={clsx(styles.button, currentBtnProps)}
            onClick={() => {
              onClose();
            }}
          >
            {fm('understood')}
          </Button>
        </div>
      ) : (
        <Button
          variant="primary"
          className={clsx(styles.button, currentBtnProps)}
          onClick={() => {
            onClose();
            onConfirm(checkedRef.current);
          }}
        >
          {buttonText}
        </Button>
      )}
    </Modal>
  );
};
